import { render, staticRenderFns } from "./SelectProductDialog.vue?vue&type=template&id=170134ea&scoped=true"
import script from "./SelectProductDialog.vue?vue&type=script&lang=js"
export * from "./SelectProductDialog.vue?vue&type=script&lang=js"
import style0 from "./SelectProductDialog.vue?vue&type=style&index=0&id=170134ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170134ea",
  null
  
)

export default component.exports